import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  message,
  Select,
  Typography,
} from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import axios from "axios";
import useAutoFocus from "../generales/hooks/useAutoFocus";
import Logo from "./images/logo.png";
import flags_us from "./images/flags_us.png";
import flags_es from "./images/flags_spanish.png";
import { useTranslation } from "react-i18next";

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});

const FormLoginHT = () => {
  // Agregar CSS para las animaciones
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes pulse {
        0% {
          box-shadow: 0 8px 25px rgba(37, 50, 137, 0.4);
        }
        50% {
          box-shadow: 0 8px 35px rgba(37, 50, 137, 0.6);
        }
        100% {
          box-shadow: 0 8px 25px rgba(37, 50, 137, 0.4);
        }
      }

      .ant-input:focus,
      .ant-input-password:focus {
        border-color: #253289 !important;
        box-shadow: 0 0 0 3px rgba(37, 50, 137, 0.1) !important;
      }

      .ant-form-item-has-error .ant-input:focus,
      .ant-form-item-has-error .ant-input-password:focus {
        border-color: #ff4d4f !important;
        box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.1) !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const autoFocusInput = useAutoFocus();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [token, setToken] = useState(null);
  const [headers, setHeaders] = useState(null);

  const [idioma, setIdioma] = useState("es");
  const { t, i18n } = useTranslation();

  // Cambiar el idioma
  const changeLanguage = (lng) => {
    // console.log(lng);
    i18n.changeLanguage(lng);
    setIdioma(lng);
    sessionStorage.setItem("idioma", lng);
  };

  useEffect(() => {
    // const userLang =
      // sessionStorage.getItem("idioma") ||
      // navigator.language ||
      // navigator.userLanguage; // Detectar idioma

      //Fijar el idioma en espanol solamente
      const userLang = "es";

    const preferredLang = userLang.startsWith("es") ? "es" : "en"; // Ajustar a 'es' o 'en'
    changeLanguage(preferredLang); // Cambiar idioma
  }, []);

  useEffect(() => {
    async function getToken() {
      try {
        const response = await Axios.post("/login", {
          username: process.env.REACT_APP_USER,
          password: process.env.REACT_APP_PASS,
        });
        let aux = response.data.token;
        sessionStorage.setItem("token", aux);
        setToken(aux);
        setHeaders({
          accept: "*/*",
          Authorization: "Bearer " + aux,
          "Content-Type": "application/json",
        });
      } catch {
        setToken(null);
        setHeaders(null);
        sessionStorage.removeItem("token");
      }
    }
    getToken();
  }, []);

  const permisosPorRol = (info_user) => {
    let funcionalidades = [];
    switch (info_user.idrol) {
      //Administrador
      case "1":
        funcionalidades = [
          "menu_usuarios",
          "menu_persona",
          "menu_manifiesto",
          "menu_paquetes",
          "menu_entregas",
          "menu_vehiculos",
          "menu_variables",
          "menu_auditoria",
          "menu_mzproducts",
        ];
        break;
      //Coordinador de rutas
      case "2":
        funcionalidades = ["menu_entregas", "menu_vehiculos"];
        break;
      //Operador de coordenadas
      case "3":
        funcionalidades = ["menu_paquetes"];
        break;
      //Repartidor
      case "4":
        funcionalidades = [];
        // funcionalidades = ["menu_paquetes"];
        break;
      default:
        funcionalidades = ["menu_auditoria"];
        break;
    }
    sessionStorage.setItem("funcionalidades", JSON.stringify(funcionalidades));
  };

  const onFinish = async (values) => {
    setLoading(true);
    if (values.user.trim() !== "" && values.pass.trim() !== "") {
      try {
        const response = await Axios.post(
          "mts/login",
          {
            correo: values.user.trim(),
            contrasenna: values.pass.trim(),
          },
          { headers: headers }
        );
        setLoading(false);
        if (response.data.success) {
          let info_user = response.data.data[0];
          sessionStorage.setItem("idusuario", info_user.idusuario);
          sessionStorage.setItem("info_user", JSON.stringify(info_user));
          permisosPorRol(info_user);
          window.location = "/principal";
          messageApi.success(response.data.message);
        } else {
          messageApi.error(response.data.message);
        }
      } catch {
        setLoading(false);
        sessionStorage.clear();
        messageApi.error(t("global.server_connection")); // Usando traducción
      }
    } else {
      setLoading(false);
      messageApi.error(t("global.missing_credentials")); // Usando traducción
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #0f1960 0%, #253289 50%, #1a237e 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Elementos decorativos de fondo */}
      <div
        style={{
          position: "absolute",
          top: "-50px",
          right: "-50px",
          width: "200px",
          height: "200px",
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "50%",
          filter: "blur(40px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-100px",
          left: "-100px",
          width: "300px",
          height: "300px",
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "50%",
          filter: "blur(60px)",
        }}
      />

      {contextHolder}
      <Row justify="center" style={{ width: "100%", zIndex: 1 }}>
        <Col
          xs={22}
          sm={18}
          md={12}
          lg={8}
          xl={6}
          style={{
            padding: "40px",
            background: "rgba(255, 255, 255, 0.95)",
            borderRadius: "24px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 25px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            animation: "fadeInUp 0.6s ease-out",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <img
              src={Logo}
              alt="Logo"
              style={{
                width: "140px",
                borderRadius: "12px",
                marginBottom: "20px"
              }}
            />
          </div>
          <Typography.Title
            level={2}
            style={{
              textAlign: "center",
              marginBottom: "40px",
              color: "#2c3e50",
              fontWeight: "600",
              fontSize: "32px",
            }}
          >
            {t("login.title")}
          </Typography.Title>
          <Form
            form={form}
            name="login_form"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="user"
              rules={[
                { required: true, message: t("error.email_required") },
                { type: "email", message: t("error.invalid_email") },
              ]}
              style={{ marginBottom: "24px" }}
            >
              <Input
                prefix={<UserOutlined style={{ color: "#253289", fontSize: "16px" }} />}
                placeholder={t("login.email")}
                ref={autoFocusInput}
                size="large"
                style={{
                  borderRadius: "12px",
                  border: "2px solid #e8e8e8",
                  height: "50px",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#253289";
                  e.target.style.boxShadow = "0 0 0 3px rgba(37, 50, 137, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e8e8e8";
                  e.target.style.boxShadow = "none";
                }}
              />
            </Form.Item>
            <Form.Item
              name="pass"
              rules={[
                { required: true, message: t("error.password_required") },
                { min: 8, message: t("error.password_min_length") },
              ]}
              style={{ marginBottom: "32px" }}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "#253289", fontSize: "16px" }} />}
                placeholder={t("login.password")}
                size="large"
                style={{
                  borderRadius: "12px",
                  border: "2px solid #e8e8e8",
                  height: "50px",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#253289";
                  e.target.style.boxShadow = "0 0 0 3px rgba(37, 50, 137, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e8e8e8";
                  e.target.style.boxShadow = "none";
                }}
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: "0" }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={loading}
                block
                style={{
                  height: "50px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(180deg, #253289 0%, #49528F 100%)",
                  fontSize: "16px",
                  fontWeight: "600",
                  boxShadow: "0 8px 25px rgba(37, 50, 137, 0.4)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 12px 35px rgba(37, 50, 137, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 8px 25px rgba(37, 50, 137, 0.4)";
                }}
              >
                {t("login.submit_button")}
              </Button>
            </Form.Item>
          </Form>

          {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Select
              value={idioma}
              onChange={changeLanguage}
              style={{
                width: 130,
                textAlign: "left",
              }}
              options={[
                {
                  value: "es",
                  label: (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        role="img"
                        aria-label="Español"
                        style={{ marginRight: 8 }}
                      >
                        🇪🇸
                      </span>
                      Español
                    </div>
                  ),
                },
                {
                  value: "en",
                  label: (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        role="img"
                        aria-label="Inglés"
                        style={{ marginRight: 8 }}
                      >
                        🇺🇸
                      </span>
                      Inglés
                    </div>
                  ),
                },
              ]}
            />
          </div> */}
        </Col>
      </Row>
    </div>
  );
};

export default FormLoginHT;
